module.exports = __webpack_public_path__ + "./kit/docs/img/big-icon-namespace.c0a1daca9632feb86025c5daa87a9521.svg";